export default __webpack_public_path__ + "locales/pl/Errors.json?hash=aa9864f33eeb4df011c00579902b887c";